export enum RecipeIngredientsManagementActionTypes {
    RECIPE_INGREDIENT_ADD = '@@recipeIngredients/RECIPE_INGREDIENT_ADD',
    RECIPE_INGREDIENT_ADD_SUCCESS = '@@recipeIngredients/RECIPE_INGREDIENT_ADD_SUCCESS',
    RECIPE_INGREDIENT_ADD_ERROR = '@@recipeIngredients/RECIPE_INGREDIENT_ADD_ERROR',

    RECIPE_INGREDIENT_LIST = '@@recipeIngredients/RECIPE_INGREDIENT_LIST',
    RECIPE_INGREDIENT_LIST_SUCCESS = '@@recipeIngredients/RECIPE_INGREDIENT_LIST_SUCCESS',
    RECIPE_INGREDIENT_LIST_ERROR = '@@recipeIngredients/RECIPE_INGREDIENT_LIST_ERROR',

    RECIPE_INGREDIENT_UPDATE = '@@recipeIngredients/RECIPE_INGREDIENT_UPDATE',
    RECIPE_INGREDIENT_UPDATE_SUCCESS = '@@recipeIngredients/RECIPE_INGREDIENT_UPDATE_SUCCESS',
    RECIPE_INGREDIENT_UPDATE_ERROR = '@@recipeIngredients/RECIPE_INGREDIENT_UPDATE_ERROR',

    RECIPE_INGREDIENT_UPDATE_STATUS = '@@recipeIngredients/RECIPE_INGREDIENT_UPDATE_STATUS',
    RECIPE_INGREDIENT_UPDATE_STATUS_SUCCESS = '@@recipeIngredients/RECIPE_INGREDIENT_UPDATE_STATUS_SUCCESS',
    RECIPE_INGREDIENT_UPDATE_STATUS_ERROR = '@@recipeIngredients/RECIPE_INGREDIENT_UPDATE_STATUS_ERROR',

    RECIPE_INGREDIENT_DELETE = '@@recipeIngredients/RECIPE_INGREDIENT_DELETE',
    RECIPE_INGREDIENT_DELETE_SUCCESS = '@@recipeIngredients/RECIPE_INGREDIENT_DELETE_SUCCESS',
    RECIPE_INGREDIENT_DELETE_ERROR = '@@recipeIngredients/RECIPE_INGREDIENT_DELETE_ERROR',

    RECIPE_INGREDIENT_ORDER_LIST = '@@recipeIngredients/RECIPE_INGREDIENT_ORDER_LIST',
    RECIPE_INGREDIENT_ORDER_LIST_SUCCESS = '@@recipeIngredients/RECIPE_INGREDIENT_ORDER_LIST_SUCCESS',
    RECIPE_INGREDIENT_ORDER_LIST_ERROR = '@@recipeIngredients/RECIPE_INGREDIENT_ORDER_LIST_ERROR',
}
